// extracted by mini-css-extract-plugin
export default {"app-body":"Body_app-body__rgkD2"};